import { useEffect } from 'react';

/** Page sentences currently mounted, by pathname. Development only. */
const mountedByPath = new Map<string, number>();
const warnedPaths = new Set<string>();

/**
 * Warns once per route, in development only, when a second page sentence
 * mounts while one is already on the page (GDN-3704, AC-6). A module-level
 * count keyed by `window.location.pathname` is enough: two sentences on one
 * page are siblings under one route, and the count returns to zero when the
 * page unmounts.
 */
export function usePageGuideMountGuard(): void {
  useEffect(() => {
    if (!import.meta.env.DEV) return undefined;
    const path = window.location.pathname;
    const count = (mountedByPath.get(path) ?? 0) + 1;
    mountedByPath.set(path, count);
    if (count > 1 && !warnedPaths.has(path)) {
      warnedPaths.add(path);
      console.warn(
        `[knowledge-base] ${count} page sentences are mounted on ${path}; a page shows one (GDN-3704, AC-6).`,
      );
    }
    return () => {
      const remaining = (mountedByPath.get(path) ?? 1) - 1;
      if (remaining > 0) mountedByPath.set(path, remaining);
      else mountedByPath.delete(path);
    };
  }, []);
}
